<div class="container">
  <div
    [ngClass]="height ? 'holder border-active' : 'holder border-disable'"
    style="right: 0px"
  >
    <input
      type="tel"
      [(ngModel)]="height"
      maxlength="3"
      (focus)="height = ''"
      (input)="checkActivatingButton()"
    />
  </div>
</div>
<div *ngIf="hasError" class="error-title">قد وارد شده اشتباه است</div>
<div class="input-title">سانتی متر</div>
